export const PAGE_KEY = 'page';
export const SIZE_KEY = 'pageSize';
